module.exports = __webpack_public_path__ + "img/profile-sample.93943ce1.png";